import React from 'react';
import Tooltip from 'react-tooltip-lite';
import { useTranslation } from 'react-i18next';
import { FaTrash } from 'react-icons/fa';
import { DELAY_HTOOLTIP } from 'global/Global';

interface IDeleteButton {
  onClick?: () => void;
}

export default function DeleteButton(props: IDeleteButton) {
  const { t } = useTranslation();
  return (
    <>
      <Tooltip direction="down" eventOff="onClick" content={t('Table.Tooltip.Delete')} hoverDelay={DELAY_HTOOLTIP}>
        <FaTrash onClick={props.onClick} color="#DE541C" size={16} className="cursor-pointer" />
      </Tooltip>
    </>
  );
}
